import {Globe, Info, Mail, Settings} from "react-feather";

const Menu = ({id, domain}) => {
    const output = {
        items: [
            {
                path : '/enterprises/:id',
                icon : <Info/>,
                label: 'Info',
                slug : 'edit'
            }
        ]
    }

    if (id) {
        output.items.push({
                path : '/enterprises/:id/settings',
                icon : <Settings/>,
                label: 'Settings',
                slug : 'settings'
            },
            {
                path : '/enterprises/:id/domains',
                icon : <Globe/>,
                label: 'Domains',
                slug : 'domains',
                paths: [
                    '/enterprises/:id/domains',
                    '/enterprises/:id/domains/edit/:id2',
                ]
            },)
    }

    if (domain?.settings?.use_mail && domain?.settings?.mail_ready) {
        output.items.push({
            path : '/enterprises/:id/domains/:id2/senders',
            icon : <Mail/>,
            label: 'Senders',
            slug : 'senders'
        })
    }

    return output
}

export default Menu